import { RemovePermitTypeData } from '@models/types';
import { actionCreatorFactory } from '../../core/utils/factories';
import {
  AddPermitTypeData,
  FinancialData,
  JurisdictionDetailsContacts,
  JurisdictionOption,
  OptionProps,
  PaginatedResponse,
  PermittingBrowse,
  PermittingJurisdictionAuditBody,
  PermittingJurisdictionAuditData,
  PermittingSofData,
  PermittingSummaryData,
  PermittingWorkflowBody,
  PermittingWorkflowData,
} from '../../models/interfaces';

const actionCreator = actionCreatorFactory('PERMITTING');

export namespace PermittingActions {
  // PERMITTING
  export const getPermittingBrowseData = actionCreator.createAsyncAction<
    PaginatedResponse<PermittingBrowse>
  >('GET_PERMITTING_BROWSE_DATA');

  export const getJurisdictionList = actionCreator.createAsyncAction<
    JurisdictionOption[]
  >('GET_JURISDICTION_LIST');

  export const getPermittingUsersOptions = actionCreator.createAsyncAction<
    OptionProps[]
  >('GET_PERMITTING_USERS');

  export const getSummaryTabData =
    actionCreator.createAsyncAction<PermittingSummaryData>(
      'GET_SUMMARY_TAB_DATA',
    );

  export const getWorkflowTabData =
    actionCreator.createAsyncAction<PermittingWorkflowData>(
      'GET_WORKFLOW_TAB_DATA',
    );

  export const getContactsTabData = actionCreator.createAsyncAction<
    JurisdictionDetailsContacts[]
  >('GET_CONTACTS_TAB_DATA');

  export const getJurisdictionAuditTabData =
    actionCreator.createAsyncAction<PermittingJurisdictionAuditData>(
      'GET_JURISDICTION_AUDIT_TAB_DATA',
    );

  export const getSofTabData =
    actionCreator.createAsyncAction<PermittingSofData>('GET_SOF_TAB_DATA');

  export const getFinancialTabData =
    actionCreator.createAsyncAction<FinancialData>('GET_FINANCIAL_TAB_DATA');

  export const setTabLoading = actionCreator.createAsyncAction<{
    tabName: string;
    isLoading: boolean;
  }>('SET_TAB_LOADING');

  export const setPermittingTypesAction = actionCreator.createAsyncAction<
    string[]
  >('SET_PERMITTING_TYPES');

  export const resetPermittingTypesAction = actionCreator.createAsyncAction<
    string[]
  >('RESET_PERMITTING_TYPES');

  export const permittingAddPermittingType =
    actionCreator.createAsyncAction<AddPermitTypeData>('ADD_PERMITTING_TYPE');

  export const permittingUpdatePermittingType =
    actionCreator.createAsyncAction<AddPermitTypeData>(
      'UPDATE_PERMITTING_TYPE',
    );

  export const permittingRemovePermittingType =
    actionCreator.createAsyncAction<RemovePermitTypeData>(
      'REMOVE_PERMITTING_TYPE',
    );

  export const permittingUpdateWorkflowData =
    actionCreator.createAsyncAction<PermittingWorkflowBody>(
      'UPDATE_WORKFLOW_DATA',
    );

  export const permittingUpdateJurisdictionAuditData =
    actionCreator.createAsyncAction<PermittingJurisdictionAuditBody>(
      'UPDATE_JURISDICTION_AUDIT_DATA',
    );

  export const resetTabsData =
    actionCreator.createAsyncAction('RESET_TABS_DATA');
}
